module.exports = __webpack_public_path__ + "static/logo-white-7558efb7f9a572f0b98522c179a745a1.png";